import formAppCanvas from './formAppCanvas';
import formAppSharedExperience from './formAppSharedExperience';
import formAppSidePanels from './formAppSidePanels';
import formAppVirtualTicketMessages from './formAppVirtualTicketMessages';

export default {
  title: 'Canvas',
  attributeName: 'appCanvas',
  getURL: 'appId/areaId/appCanvasPlay',
  createURL: '',
  updateURL: 'appId/areaId/appCanvasPlay',
  removeURL: '',
  sessionParams: ['appId', 'areaId'],
  autoUpdate: false,
  formConfig: [
    formAppCanvas,
    formAppSidePanels,
    formAppSharedExperience,
    formAppVirtualTicketMessages,
  ],
};
